<template>
  <a @click="playPlaylist" class="table-icon tooltip" :class="{ 'is-busy': isLoading }" data-tooltip="Play Playlist">
    <IconPlay/>
  </a>
</template>

<script>
import { IconPlay } from '@/Icons/IconBase'
import { AUDIO_PLAYER_LOAD, QUEUED_AUDIO_FILE_USER_ALL, QUEUED_AUDIO_FILE_USER_CREATE_BY_PLAYLIST, QUEUED_AUDIO_FILE_USER_UPDATE } from '@/store/actions'
import moment from 'moment'

export default {
  name: 'PlayPlaylistButton',
  props: ['playlistId'],
  components: {
    IconPlay
  },
  data() {
    return {
      isLoading: false
    }
  },
  methods: {
    playPlaylist() {
      if (this.isLoading) {
        return
      }

      let self = this
      this.isLoading = true
      this.$store.dispatch(QUEUED_AUDIO_FILE_USER_CREATE_BY_PLAYLIST, {
        playlist_id: this.playlistId,
        overwrite: true
      })
        .then(function (queue) {
          self.playQueuedAudioFiles(queue)
        })
        .catch(function (err) {
          self.$store.commit('error', `Could not play playlist.`)
          console.log(err)
        })
        .finally(function () {
          self.isLoading = false
        })
    },

    // Uses the queue the enqueue request already returned rather than fetching it again.
    playQueuedAudioFiles(queue) {
      let self = this
      if (!queue || !queue.length) {
        return
      }

      this.$store.dispatch(AUDIO_PLAYER_LOAD, { id: queue[0].audio_file_id })
      this.$store.dispatch(QUEUED_AUDIO_FILE_USER_UPDATE, {
        id: queue[0].id,
        data: {
          played_at: moment().utc().format('YYYY-MM-DD HH:mm:ss')
        }
      }).then(function () {
        self.$store.dispatch(QUEUED_AUDIO_FILE_USER_ALL)
      })
    }
  }
}
</script>
